import { FormStyle, getLocaleDayNames, getLocaleMonthNames, TranslationWidth } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { RRule } from 'rrule';

@Pipe({
  name: 'rrule'
})
export class RrulePipe implements PipeTransform {

  translation = {
    'every': $localize`:@@RrulePipe.every:every`,
    'until': $localize`:@@RrulePipe.until:until`,
    'day': $localize`:@@RrulePipe.day:day`,
    'days': $localize`:@@RrulePipe.days:days`,
    'weekdays': $localize`:@@RrulePipe.weekdays:weekdays`,
    'week': $localize`:@@RrulePipe.week:week`,
    'weeks': $localize`:@@RrulePipe.weeks:weeks`,
    'year': $localize`:@@RrulePipe.year:year`,
    'years': $localize`:@@RrulePipe.years:years`,
    'on': $localize`:@@RrulePipe.on:on`,
    'month': $localize`:@@RrulePipe.month:month`,
    'months': $localize`:@@RrulePipe.months:months`,
    'on the': $localize`:@@RrulePipe.onthe:on the`,
    'and': $localize`:@@RrulePipe.and:and`,
    'nd': $localize`:@@RrulePipe.nd:nd`,
    'rd': $localize`:@@RrulePipe.rd:rd`,
    'st': $localize`:@@RrulePipe.st:st`,
    'th': $localize`:@@RrulePipe.th:th`,
    'last': $localize`:@@RrulePipe.last:last`
  };

  dayNames: string[];
  monthNames: string[];

  constructor(@Inject(LOCALE_ID) private locale: string) {
    this.dayNames = [...getLocaleDayNames(locale, FormStyle.Standalone, TranslationWidth.Abbreviated)];
    this.monthNames = [...getLocaleMonthNames(locale, FormStyle.Standalone, TranslationWidth.Abbreviated)];
  }

  transform(value: any, defaultValue?: any): any {
    if (value == null) {
      return defaultValue;
    }

    let rule: any;;
    if (typeof value === 'string') {
      rule = new RRule(RRule.parseString(value));
    } else {
      rule = value;
    }

    return rule.toText((id: keyof typeof this.translation) => {
      return this.translation[id] ?? id;
    }, {dayNames: this.dayNames, monthNames: this.monthNames});
  }

}
/*
export class RRuleService {

  // date-related translations
  strings: any = {
      da: {
          'every': 'hver',
          'until': 'indtil',
          'day': 'dag',
          'days': 'dage',
          'weekdays': 'hverdage',
          'week': 'uge',
          'weeks': 'uger',
          'year': 'år',
          'years': 'år',
          'on': 'på',
          'month': 'måned',
          'months': 'måned',
          'on the': 'på den',
          'and': 'og',
          'nd': '.',
          'rd': '.',
          'st': '.',
          'th': '.',
          'last': 'sidste'
      }
  };

  i18n: any = {};

  constructor(private $locale: ng.ILocaleService, private $log: ng.ILogService) {
      $log.info('Initializing RRuleService');
      this.i18n.dayNames = angular.copy($locale['DATETIME_FORMATS']['DAY']);
      this.i18n.monthNames = angular.copy($locale['DATETIME_FORMATS']['MONTH']);

      var language = this.getLanguage();

      switch (language) {
          case 'da':
              for (var i = 0; i < this.i18n.dayNames.length; i++) {
                  this.i18n.dayNames[i] = this.i18n.dayNames[i] + 'e';
              }
              break;
      }

      if (angular.isDefined(this.strings[language])) {
          this.i18n.strings = this.strings[language];
      }
  }

  private getLanguage(): string {
      return this.$locale.id.split('_')[0];
  }

  public toText(rule) {
      if (rule == null) {
          return null;
      }

      var that = this;
      return rule.toText((id) => {
          var language: string = this.getLanguage();
          return angular.isDefined(that.i18n.strings) ? that.i18n.strings[id] : id;
      }, this.i18n);
  }
}
*/
